(function () {
  'use strict';

  function onSubmit(e) {
    var form = e.target.closest('[data-inline-quick-buy-form]');
    if (!form) return;
    e.preventDefault();

    var container = form.closest('[data-inline-quick-buy]');
    var button = form.querySelector('[data-inline-quick-buy-submit]');
    var label = form.querySelector('[data-inline-quick-buy-label]');
    var message = container ? container.querySelector('[data-inline-quick-buy-message]') : null;
    var variantInput = form.querySelector('select, input[type="hidden"]');

    if (!variantInput || !variantInput.value || button.disabled) return;

    var originalLabel = label.textContent;
    button.disabled = true;
    label.textContent = 'Adding...';
    if (message) message.textContent = '';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantInput.value, quantity: 1 })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw new Error(data.description || data.message || 'Could not add to cart.');
          }
          return data;
        });
      })
      .then(function () {
        label.textContent = 'Added!';
        if (message) message.textContent = '';
        openCartDrawer();
        setTimeout(function () {
          label.textContent = originalLabel;
          button.disabled = false;
        }, 1600);
      })
      .catch(function (err) {
        label.textContent = originalLabel;
        button.disabled = false;
        if (message) message.textContent = err.message;
      });
  }

  function openCartDrawer() {
    /*
      Monster Upsells (this store's cart drawer app) exposes a documented
      refresh method per their own developer docs:
      https://monsterapps.crisp.help/en/article/developer-documents-methodscss-selectors-jwxlnk/

      window.monster_refresh(open, callback) re-reads the real Shopify cart
      and, when open=true, opens the drawer showing the correct contents.
      This replaces the earlier guesswork of dispatching generic custom
      events, which this app does not listen for.
    */
    if (typeof window.monster_refresh === 'function') {
      window.monster_refresh(true, function () {
        updateHeaderCartCount();
      });
      return;
    }

    /* Fallback: if Monster Upsells isn't present/loaded, at least keep the
       theme's own header cart count accurate. */
    updateHeaderCartCount();
  }

  function updateHeaderCartCount() {
    fetch('/cart.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var cartLinks = document.querySelectorAll('a.cart:not(.nav-search)');
        cartLinks.forEach(function (link) {
          var countEl = link.querySelector('div');
          if (countEl) countEl.textContent = cart.item_count;
          var textLink = link.querySelector('.text-link');
          if (textLink) {
            var base = textLink.dataset.baseLabel || textLink.textContent.replace(/\s*\(\d+\)\s*$/, '');
            textLink.dataset.baseLabel = base;
            textLink.textContent = cart.item_count > 0 ? base + ' (' + cart.item_count + ')' : base;
          }
        });
      })
      .catch(function () {
        /* Item was still added to the real cart even if this refresh step failed */
      });
  }

  document.addEventListener('submit', onSubmit);
})();
